/**
 * The website that belongs to this environment (www.aventuria.mx in production). Guests arrive
 * from it, the guest bar carries its menu, and each trip's indexable page lives there
 * (/viajes/:slug), so the app's trip page names it as canonical.
 */
export const WEBSITE_URL = ((import.meta.env.VITE_WEBSITE_URL as string | undefined) || "https://www.aventuria.mx").replace(/\/+$/, "");

export const websiteTripUrl = (slug: string) => `${WEBSITE_URL}/viajes/${encodeURIComponent(slug)}`;

/** Points search engines at the website's page for this trip while the app's page is open. */
export function setCanonical(href: string | null): () => void {
  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  const created = !link;
  if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.append(link); }
  const previous = link.href;
  if (href) link.href = href;
  return () => { if (created) link?.remove(); else if (link) link.href = previous; };
}
